import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import ReactSelect from "../../UI/ReactSelect";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import InputMask from "react-input-mask";


export default function Edit(props) {
  const {
    onHide,
    show,
    humanResource,
    onHumanResources,
    skip,
    take,
    sortField,
    orderBy,
    assets,
  } = props;
  const { id, assetId, firstName, lastName, email, phone } = humanResource;
  const [isError, setIsError] = useState("");
  const [assetsOptions, setAssetsOptions] = useState([]);

  const [assetsOption, setAssetsOption] = React.useState(null);

  function handleChangeAsset(value, setFieldValue) {
    setAssetsOption((prevState) => value);
    setFieldValue("assetId", value.value);
  }

  useEffect(() => {
    setAssetsOptions(
      assets.map((suggestion) => ({
        value: suggestion.id,
        label: suggestion.name,
      }))
    );
  }, [assets]);

  useEffect(() => {
    setAssetsOption((prev) =>
      assetsOptions.find((option) => option.value === assetId)
    );
  }, [assetId, assetsOptions]);

  useEffect(() => {
    if (!show) {
      setAssetsOption(null);
    }
  }, [show]);

  const onPutHumanResource = (values, resetForm, setSubmitting) => {
    const humanResource = {
      id: id,
      assetId: values.assetId,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}humanResource`, humanResource, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onHumanResources(skip, take, sortField, orderBy);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const EditSchema = Yup.object().shape({
    assetId: Yup.string().required("Asset Id is required"),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().required("Email is required")
    .email("Wrong email format. E.g. jhon.doe@example.com")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    ,
    phone: Yup.string().required("Phone is required"),
  });

  const getInputClasses = (touched, errors, fieldName) => {
    if (touched[fieldName] && errors[fieldName]) {
      return true;
    }
    if (touched[fieldName] && errors[fieldName]) {
      return false;
    }

    return false;
  };

  // useEffect(() => {
  // }, [assetsOption, assetId]);

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="sm"
      aria-labelledby="edit"
      className="modal-right pr-0"
    >
      {humanResource &&
        Object.keys(humanResource).length !== 0 &&
        humanResource.constructor === Object && (
          <Formik
            initialValues={{
              assetId: assetId,
              firstName: firstName,
              lastName: lastName,
              email: email,
              phone: phone,
            }}
            validationSchema={EditSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
              onPutHumanResource(values, resetForm, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              handleChange,
              handleBlur,
              resetForm,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title id="edit">Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-12 pl-4 pr-4">
                    <div className="row">
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <ReactSelect
                            suggestions={assetsOptions}
                            handleChangeSingle={(value) =>
                              handleChangeAsset(value, setFieldValue)
                            }
                            single={assetsOption}
                            label="Asset Id"
                            placeholder="Asset Id"
                            error={getInputClasses(touched, errors, "assetId")}
                            inputId="assetId"
                          />
                        </div>

                        {touched.assetId && errors.assetId ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.assetId}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="firstName"
                            label="First name"
                            placeholder="First name"
                            className="w-100"
                            value={values.firstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(
                              touched,
                              errors,
                              "firstName"
                            )}
                          />
                        </div>
                        {touched.firstName && errors.firstName ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.firstName}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="lastName"
                            label="Last name"
                            placeholder="Last name"
                            className="w-100"
                            value={values.lastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "lastName")}
                          />
                        </div>
                        {touched.lastName && errors.lastName ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.lastName}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="email"
                            label="Email"
                            placeholder="Email"
                            className="w-100"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "email")}
                          />
                        </div>
                        {touched.email && errors.email ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.email}</div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {/* <TextField
                            id="phone"
                            label="Phone"
                            placeholder="Phone"
                            className="w-100"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "phone")}
                          /> */}
                          <InputMask
                            mask="\9\94999999999"
                            value={values.phone}
                            // onChange={(e) => handleChangePhoneNumber(e)}
                            onChange={handleChange}
                            disabled={false}
                            maskChar=""
                            id="phone"
                            type="number"
                          >
                            {() =>
                              <TextField
                                label="Phone number"
                                placeholder="Phone number"
                                className="w-100"
                                name="phone"
                              // onKeyDown={handleEnter}

                              // error={getInputClasses("phone")}
                              // {...formik.getFieldProps("phone")}
                              />}
                          </InputMask>
                        </div>
                        {touched.phone && errors.phone ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.phone}</div>
                          </div>
                        ) : null}
                        {isError && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block MuiFormLabel-root Mui-error">
                              {isError}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="light"
                    onClick={() => {
                      onHide(false);
                      resetForm();
                    }}
                  >
                    Close
                  </Button>
                  <Button type="submit">Edit</Button>
                </Modal.Footer>
              </form>
            )}
          </Formik>
        )}
    </Modal>
  );
}
